module.exports = __webpack_public_path__ + "img/PL09093.d44967db.png";